import { useLogOutMutation } from 'api/auth';
import User from 'types/User';
import Avatar from 'components/Avatar';
import { useTranslation } from 'react-i18next';
import {
  LumenDropdownMenu,
  LumenDropdownMenuItem,
} from '@photoshelter/socialie-components';

interface Props {
  currentUser: User;
}

export default function UserMenu({ currentUser }: Props) {
  const [logOut] = useLogOutMutation();
  const { t } = useTranslation();
  const handleLogOut = async () => {
    await logOut();
    window.location.reload();
  };

  return (
    <LumenDropdownMenu
      className="dark"
      renderTrigger={
        <button className="h-4 w-4 shrink-0">
          <Avatar src={currentUser.avatarUrl} name={currentUser.name} />
        </button>
      }
    >
      <LumenDropdownMenuItem asChild>
        <a
          href="https://www.photoshelter.com/profile/bio"
          target="_blank"
          rel="noreferrer"
        >
          {t('globalMenu.userMenu.profile')}
        </a>
      </LumenDropdownMenuItem>

      <LumenDropdownMenuItem asChild>
        <a
          href="https://www.socialie.com/privacy-policy/"
          target="_blank"
          rel="noreferrer"
        >
          {t('globalMenu.userMenu.privacyPolicy')}
        </a>
      </LumenDropdownMenuItem>

      <LumenDropdownMenuItem onSelect={handleLogOut}>
        {t('globalMenu.userMenu.logOut')}
      </LumenDropdownMenuItem>
    </LumenDropdownMenu>
  );
}
